<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
import axios from 'axios';
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Income Statement",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,
  },
  data() {
    return {
      title: "INCOME STATEMENT",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "INCOME STATEMENT",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },        
        {
          key: "account",
          sortable: true,
          label: "PARTICULARS",
        },
        {
          key: "dr",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "cr",
          sortable: true,
          label: "AMOUNT",
        }
      ],
      
      // make inputs required
      accountError: "",
      amountError: "",
      // delete category
      deletedata: {
        name: "",
        id: "",
      },
      total_credit:0,
      total_debit:0,      

      filterData: {
        time: "annual",
        datefrom: new Date(new Date().getFullYear(), 0, 1).toLocaleDateString('en-CA'),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        year: new Date().getFullYear(),
        branch_id:0
      },
      dashboardLabel: new Date().getFullYear()+"'s", 
      timeFilters: [
        { title: "Annual", value: "annual" },
        { title: "This month", value: "month" },
        { title: "This quarter", value: "quarter" },
        { title: "Customize", value: "custom" },
      ],
      currentYear: new Date().getFullYear(),
      
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("coa", ["IncomeStatement","filterStatus","RevenueDetails",
    "CostofsalesDetails","ExpenseDetails","OtherincomeDetails"]),
    ...mapGetters("auth", ["MyUserPerm"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.IncomeStatement ? this.IncomeStatement.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.IncomeStatement ? this.IncomeStatement.length : 1;
  },
  // updated(){
  // },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },

    'filterData.dateRange': function (newDateRange) {
      // Check if the selected date range is outside the current year
      if (
        newDateRange[0].getFullYear() !== this.currentYear ||
        newDateRange[1].getFullYear() !== this.currentYear
      ) {
        // If outside the current year, reset the date range
        this.filterData.dateRange = [];
      }
    }
  },
  methods: {
    ...mapActions({
      FetchStatement: "coa/fetchIncomestatement",
      FetchRevenue: "coa/fetchRevenueDetails",
      FetchCostofSales: "coa/fetchCostofsalesDetails",
      FetchExpenses: "coa/fetchExpenseDetails",
      FetchOtherincome: "coa/fetchOtherincomeDetails",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    resetErrors() {
        this.acountError = "";
        this.amountError = "";
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    setLabel() {
      if (this.filterData.time == "annual") {
        this.dashboardLabel = this.filterData.year+"'s";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "month") {
        this.dashboardLabel = "This month's";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "quarter") {
        this.dashboardLabel = "This quarter's";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "custom") {
        this.dashboardLabel = this.filterData.datefrom+' to '+this.filterData.dateto;
      }
    },

    FetchIncomeStatement(){
      this.FetchStatement(this.filterData);
    },

    Excel_export() {
      axios
        .post("export_is", this.filterData,{
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "income_statement.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {
        });
    },

    ExpandAccount(account){
      if(account == 'Revenue'){
        this.FetchRevenue(this.filterData);
      }else if(account == 'CostofSales'){
        this.FetchCostofSales(this.filterData);
      }else if(account == 'Expenses'){
        this.FetchExpenses(this.filterData);
      }else if(account == 'Otherincome'){
        this.FetchOtherincome(this.filterData);
      }
    },

    ResetAccount(account){
      if(account == 'Revenue'){
        this.FetchRevenue();
      }else if(account == 'CostofSales'){
        this.FetchCostofSales();
      }else if(account == 'Expenses'){
        this.FetchExpenses();
      }else if(account == 'Otherincome'){
        this.FetchOtherincome();
      }
    }
  },
  created() {
    this.FetchStatement(this.filterData);
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row" style="font-size: medium;">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
                <h3 class="card-title mb-4 text-center">{{dashboardLabel}} INCOME STATEMENT</h3>
            </div> 
            <div class="row"> 
              <div class="col-md-2 mt-4">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                >
              </div>   
              <div class="col-md-2">
                <label>FILTER BY TIME</label>
                <model-list-select
                  :list="this.timeFilters ? this.timeFilters : []"
                  v-model="filterData.time"
                  option-value="value"
                  size="sm"
                  @input="setLabel(), FetchIncomeStatement()"
                  option-text="title"
                  placeholder="Select Performance"
                >
                </model-list-select>
              </div>
              <div class="col-md-3" v-show="filterData.time == 'annual'">
                <label>ENTER YEAR</label>
                <input type="year"
                  class="form-control"
                  v-model="filterData.year"
                  lang="en"
                  @keyup.enter="setLabel(), FetchIncomeStatement()"
                />
              </div>
              <div class="col-md-3" v-show="filterData.time == 'custom'">
                <label>FROM</label>
                <input type="date"
                  class="form-control"
                  v-model="filterData.datefrom"
                  lang="en"
                  @keyup.enter="setLabel(), FetchTransactions()"
                />
              </div>
              <div class="col-md-3" v-show="filterData.time == 'custom'">
                <label>TO</label>
                <input type="date"
                  class="form-control"
                  v-model="filterData.dateto"
                  lang="en"
                  @keyup.enter="setLabel(), FetchTransactions()"
                />
              </div>
              <div class="col-md-2 mt-4" align="right">
                <button class="btn btn-warning" type="button" @click="FetchIncomeStatement()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div v-if="IncomeStatement">
              <table class="table-responsive mb-0 table" align="center">
                <thead class="h4">
                  <tr>
                    <th>Particulars</th>
                    <th>Amount</th>
                  </tr>                  
                </thead>
                <tbody>
                  <tr class="h5">
                    <td>Revenue
                      <button class="btn btn-sm btn-link" @click="ExpandAccount('Revenue')">
                          <b-spinner
                            v-if="filterStatus"
                            variant="primary"
                            small
                            label="Spinning"
                          ></b-spinner>
                        <b> Expand <i class="fa fa-arrow-down"></i></b>
                      </button> 
                      <button class="btn btn-sm btn-link" @click="ResetAccount('Revenue')">
                        <b> Collapse <i class="fa fa-arrow-up"></i></b>
                      </button>                                                                  
                    </td>
                    <td>{{ IncomeStatement.sales.toLocaleString() }}</td>
                  </tr>
                  <tr v-for="(item, index) in RevenueDetails" :key="index" style="font-size: 14px;">
                    <td>{{ item.name }}</td>
                    <td>{{ item.amount?item.amount.toLocaleString():0 }}</td>
                  </tr> 
                  <tr class="h5">
                    <td>Cost of Goods Sold
                      <button class="btn btn-sm btn-link" @click="ExpandAccount('CostofSales')">
                          <b-spinner
                            v-if="filterStatus"
                            variant="primary"
                            small
                            label="Spinning"
                          ></b-spinner>
                        <b> Expand <i class="fa fa-arrow-down"></i></b>
                      </button>
                      <button class="btn btn-sm btn-link" @click="ResetAccount('CostofSales')">
                        <b> Collapse <i class="fa fa-arrow-up"></i></b>
                      </button>                       
                    </td>
                    <td>{{ IncomeStatement.costofsales.toLocaleString() }}</td>
                  </tr>
                  <tr v-for="(item, index) in CostofsalesDetails" :key="index" style="font-size: 14px;">
                    <td>{{ item.name }}</td>
                    <td>{{ item.amount?item.amount.toLocaleString():0 }}</td>
                  </tr>
                  <tr class="h5">
                    <td>Gross Profit</td>
                    <td>{{ (IncomeStatement.sales-IncomeStatement.costofsales).toLocaleString() }}</td>
                  </tr>
                  <tr class="h5">
                    <td>Other incomes or losses
                      <button class="btn btn-sm btn-link" @click="ExpandAccount('Otherincome')">
                          <b-spinner
                            v-if="filterStatus"
                            variant="primary"
                            small
                            label="Spinning"
                          ></b-spinner>
                        <b> Expand <i class="fa fa-arrow-down"></i></b>
                      </button>
                      <button class="btn btn-sm btn-link" @click="ResetAccount('Otherincome')">
                        <b> Collapse <i class="fa fa-arrow-up"></i></b>
                      </button> 
                    </td>
                    <td>{{ IncomeStatement.otherincome.toLocaleString() }}</td>
                  </tr>
                  <tr v-for="(item, index) in OtherincomeDetails" :key="index" style="font-size: 14px;">
                    <td>{{ item.name }}</td>
                    <td>{{ item.amount?(item.amount).toLocaleString():0 }}</td>
                  </tr>
                  <tr class="h5">
                    <td>Less Operating Expenses
                      <button class="btn btn-sm btn-link" @click="ExpandAccount('Expenses')">
                          <b-spinner
                            v-if="filterStatus"
                            variant="primary"
                            small
                            label="Spinning"
                          ></b-spinner>
                        <b> Expand <i class="fa fa-arrow-down"></i></b>
                      </button>    
                      <button class="btn btn-sm btn-link" @click="ResetAccount('Expenses')">
                        <b> Collapse <i class="fa fa-arrow-up"></i></b>
                      </button>                  
                    </td>
                    <td>{{ IncomeStatement.expenses.toLocaleString() }}</td>
                  </tr>
                  <tr v-for="(item, index) in ExpenseDetails" :key="index" style="font-size: 14px;">
                    <td>{{ item.name }}</td>
                    <td>{{ item.amount?(item.amount).toLocaleString():0 }}</td>
                  </tr> 
                  <tr class="h5">
                    <td>Operating Profit/Loss</td>
                    <td><b>{{ ((IncomeStatement.sales+IncomeStatement.otherincome)-(IncomeStatement.expenses+IncomeStatement.costofsales)).toLocaleString() }}</b></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Loader v-if="!IncomeStatement"/>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>   
